import { inject } from 'mobx-react';
import * as React from 'react';
import { APIErrorMap, nonFieldErrorsKey } from '../../api/api';
import { InjectTranslate } from '../app/app';

interface FormErrorsOverviewProps {
  readonly errors: APIErrorMap<string> | undefined;
}

class FormErrorsOverviewC extends React.Component<FormErrorsOverviewProps & InjectTranslate> {
  public render() {
    const { errors, t } = this.props;

    if (!errors || !Object.keys(errors).length)
      return null;

    const nonFieldErrors = errors[nonFieldErrorsKey];
    if (nonFieldErrors)
      return (
        <div className="well well-error form-errors">
          <span className="section-header">{t('common.errors.list')}</span>
          <ul>
            {nonFieldErrors.map((error, index) => (
              <li key={index} className="form-error">{t(error, undefined, true)}</li>
            ))}
          </ul>
        </div>
      );

    return (
      <div className="well well-error form-errors">
        <span className="section-header">{t('common.errors.general')}</span>
      </div>
    );
  }
}

export const FormErrorsOverview = inject('t')(FormErrorsOverviewC) as React.ComponentClass<FormErrorsOverviewProps>;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/form-errors-overview.tsx